import AccordionSetup from "../AccordionSetup";
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import EventMap from "./EventMap";
import { EventDto } from "../../../interfaces/IEvent";
import { Typography } from "@mui/material";

interface MapContainerProps {
    viewEvent: EventDto;
}

function MapContainer({ viewEvent }: MapContainerProps){
    return (
        <AccordionSetup 
            title="Kartvisning" 
            icon={<MapOutlinedIcon /> }
        >
            {viewEvent.affectedCustomers?.length > 0 
                ? <EventMap viewEvent={viewEvent}/> 
                : <Typography variant="body2">
                    Ingen berørte kunder å vise i kart.
                </Typography>
            }
        </AccordionSetup>
    );
}

export default MapContainer;